import { FunctionComponent, useEffect, useState } from 'react'
import { colors } from 'shared/styles/colors'
import { firebaseRemoteConfig } from 'shared/services/FirebaseServices'
import appleStore from 'shared/assets/images/app-store-4.svg'
import qrCodeTmovFrotista from 'shared/assets/images/qrCodeTmovFrotista.png'
import googlePlay from 'shared/assets/images/google-play-4.svg'
import Drawer from 'shared/components/Drawer'
import { Text, Title, Container, ContainerInfo, Info, QrCode } from './styles'
import Grid from '@material-ui/core/Grid'
import { Divider } from '@material-ui/core'

interface AppTmovFrotistaProp {
  open: boolean
  setOpen(open: boolean)
}
const AppTmovFrotista: FunctionComponent<AppTmovFrotistaProp> = ({
  open,
  setOpen,
}) => {
  const [urlAppleStore, setUrlAppleStore] = useState('')
  const [urlPlayStore, setUrlPlayStore] = useState('')

  useEffect(() => {
    const init = async () => {
      const resultGetUrlPlayStore = await firebaseRemoteConfig.getUrlPlayStore()
      const resultGetUrlAppleStore =
        await firebaseRemoteConfig.getUrlAppleStore()
      setUrlAppleStore(resultGetUrlAppleStore)
      setUrlPlayStore(resultGetUrlPlayStore)
    }
    init()
  }, [])
  return (
    <Drawer open={open} onCloseModal={() => setOpen(false)} width="400px">
      <Container>
        <Title>Complete seu cadastro pelo app Tmov Frotista</Title>
        <Text>
          Abra a câmera do celular e aponte para o QR Code abaixo para baixar o
          app.
        </Text>
        <Grid
          container
          justifyContent="center"
          alignContent="center"
          alignItems="center"
        >
          <Grid container justifyContent="center" style={{ padding: 18 }}>
            <QrCode src={qrCodeTmovFrotista} />
          </Grid>
          <Grid
            container
            justifyContent="center"
            alignContent="center"
            alignItems="center"
            style={{ padding: 18 }}
          >
            <Grid item md={6}>
              <img
                style={{ cursor: 'pointer' }}
                src={googlePlay}
                onClick={() => {
                  window.open(urlPlayStore, '_blank')
                }}
              />
            </Grid>
            <Grid item md={6}>
              <img
                loading="lazy"
                style={{ cursor: 'pointer' }}
                src={appleStore}
                onClick={() => {
                  window.open(urlAppleStore, '_blank')
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid style={{ marginTop: 24, marginBottom: 24, width: '100%' }}>
          <Divider style={{ width: '90%' }} />
        </Grid>
        <Text>
          Para abrir a conta pelo celular é só fazer login no app com os mesmos
          dados da plataforma web. Abrir o menu Tmov Pay e iniciar o cadastro!
        </Text>
      </Container>
    </Drawer>
  )
}

export default AppTmovFrotista
